import { Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import Loader from "./Components/Assets/Loader/Loader";
import ProtectedRoutes from "./Components/Authentications/ProtectedRoutes";

// Lazy-loaded components
const Login = lazy(() => import("./Components/Authentications/Login"));
const Dashboard = lazy(() => import("./Components/Pages/Dashboard/Dashboard"));
const UserManagement = lazy(() =>
  import("./Components/Pages/UserManagement/UserManagement")
);
const MyProfile = lazy(() => import("./Components/Pages/Profile/MyProfile"));
const DriverManagement = lazy(() =>
  import("./Components/Pages/DriverManagement/DriverManagement")
);
const DriverView = lazy(() =>
  import("./Components/Pages/DriverManagement/DriverView")
);
const UserView = lazy(() =>
  import("./Components/Pages/UserManagement/UserManagementDetails")
);
const CategoryManagement = lazy(() => import('./Components/Pages/CategoryManagement/CategoryManagement'))
const ViewCategory = lazy(() => import('./Components/Pages/CategoryManagement/ViewCategory'))
const AddCategory = lazy(() => import('./Components/Pages/CategoryManagement/AddCategory'))
const EditCategory = lazy(() => import('./Components/Pages/CategoryManagement/EditCategory'))
const StaffMemberManagement = lazy(() => import('./Components/Pages/StaffMemberManagement/StaffMemberManagement'))
const StaffMemberManagementView = lazy(() => import('./Components/Pages/StaffMemberManagement/StaffMemberView'))
const StaffMemberManagementEdit = lazy(() => import('./Components/Pages/StaffMemberManagement/StaffEdit'))
const StaffMemberManagementAdd = lazy(() => import('./Components/Pages/StaffMemberManagement/StaffAdd'))
const ProductManagement = lazy(() => import("./Components/Pages/ProductManagement/ProductManagement"))
const ProductManagementView = lazy(() => import('./Components/Pages/ProductManagement/ProductManagementView'))
const ProductManagementEdit = lazy(() => import('./Components/Pages/ProductManagement/ProductManagementEdit'))
const ProductManagementAdd = lazy(() => import("./Components/Pages/ProductManagement/ProductManagementAdd"))
const ContentManagement = lazy(() => import('./Components/Pages/ContentManagement/ContentManagement'))
const ContentManagementEdit = lazy(() => import('./Components/Pages/ContentManagement/EditContent'))
const ContentManagementView = lazy(() => import('./Components/Pages/ContentManagement/ViewContent'))
const HelpAndSupport = lazy(() => import('./Components/Pages/HelpAndSupport/HelpAndSupport'))
const HelpAndSupportView = lazy(() => import('./Components/Pages/HelpAndSupport/HelpAndSupportView'))
const OrderManagement = lazy(() => import('./Components/Pages/OrdersManagement/OrdersManagement'))
const OrderManagementView = lazy(() => import('./Components/Pages/OrdersManagement/OrderManagementView'))
const TransactionManagement = lazy(() => import('./Components/Pages/TransactionManagement/TransactionManagement'))
const ChemicalTenderManagement = lazy(() => import('./Components/Pages/ChemicalTenderManagement/ChemicalTenderManagement'))
const ChemicalTenderManagementView = lazy(() => import('./Components/Pages/ChemicalTenderManagement/ChemicalTenderManagementView'))
const SubscriptionManagement = lazy(() => import('./Components/Pages/SubscriptionPlanManagement/SubscriptionManagement'))
const SubscriptionManagementView = lazy(() => import('./Components/Pages/SubscriptionPlanManagement/ViewSubscription'))
const SubscriptionManagementAdd = lazy(() => import('./Components/Pages/SubscriptionPlanManagement/CreateSubscription'))
const SubscriptionManagementEdit = lazy(() => import('./Components/Pages/SubscriptionPlanManagement/EditSubscription'))
const AddChemical = lazy(() => import('./Components/Pages/ChemicalTenderManagement/AddChemical'))
const EditChemical = lazy(() => import('./Components/Pages/ChemicalTenderManagement/EditChemical'))
const ComissionManagement = lazy(()=>import('./Components/Pages/ComissionManagement/ComissionManagement'))
const DocumentRequestManagement = lazy(()=>import('./Components/Pages/DocumentRequestManagement/DocumentRequestManagement'))
const DocumentRequestManagementView = lazy(()=>import('./Components/Pages/DocumentRequestManagement/DocumentRequestManagementView'))
function App() {
  return (
    <Routes>
      {/* Public Route */}
      <Route
        path="*"
        element={
          <Suspense fallback={<Loader />}>
            <Login />
          </Suspense>
        }
      />

      {/* Protected Routes */}
      <Route element={<ProtectedRoutes />}>
        <Route
          path="/Dashboard"
          element={
            <Suspense fallback={<Loader />}>
              <Dashboard />
            </Suspense>
          }
        />
        <Route
          path="/UserManagement"
          element={
            <Suspense fallback={<Loader />}>
              <UserManagement />
            </Suspense>
          }
        />
        <Route
          path="/MyProfile"
          element={
            <Suspense fallback={<Loader />}>
              <MyProfile />
            </Suspense>
          }
        />
        <Route
          path="/DriverManagement"
          element={
            <Suspense fallback={<Loader />}>
              <DriverManagement />
            </Suspense>
          }
        />
        <Route
          path="/DriverManagement/:id"
          element={
            <Suspense fallback={<Loader />}>
              <DriverView />
            </Suspense>
          }
        />
        <Route
          path="/UserManagement/:id"
          element={
            <Suspense fallback={<Loader />}>
              <UserView />
            </Suspense>
          }
        />
        <Route
          path="/CategoryManagement"
          element={
            <Suspense fallback={<Loader />}>
              <CategoryManagement />
            </Suspense>
          }
        />
          <Route
          path="/ComissionManagement"
          element={
            <Suspense fallback={<Loader />}>
              <ComissionManagement />
            </Suspense>
          }
        />
        <Route
          path="/CategoryManagement/:id"
          element={
            <Suspense fallback={<Loader />}>
              <ViewCategory />
            </Suspense>
          }
        />
        <Route
          path="/CategoryManagement/AddCategory"
          element={
            <Suspense fallback={<Loader />}>
              <AddCategory />
            </Suspense>
          }
        />
        <Route
          path="/CategoryManagement/EditCategory/:id"
          element={
            <Suspense fallback={<Loader />}>
              <EditCategory />
            </Suspense>
          }
        />
        <Route
          path="/StaffMemberManagement"
          element={
            <Suspense fallback={<Loader />}>
              <StaffMemberManagement />
            </Suspense>
          }
        />
        <Route
          path="/StaffMemberManagement/Edit/:id"
          element={
            <Suspense fallback={<Loader />}>
              <StaffMemberManagementEdit />
            </Suspense>
          }
        />
        <Route
          path="/StaffMemberManagement/Add"
          element={
            <Suspense fallback={<Loader />}>
              <StaffMemberManagementAdd />
            </Suspense>
          }
        />
        <Route
          path="/StaffMemberManagement/:id"
          element={
            <Suspense fallback={<Loader />}>
              <StaffMemberManagementView />
            </Suspense>
          }
        />

        <Route
          path="/ProductManagement"
          element={
            <Suspense fallback={<Loader />}>
              <ProductManagement />
            </Suspense>
          }
        />
        <Route
          path="/ProductManagement/:id"
          element={
            <Suspense fallback={<Loader />}>
              <ProductManagementView />
            </Suspense>
          }
        />
        <Route
          path="/ProductManagement/Edit/:id"
          element={
            <Suspense fallback={<Loader />}>
              <ProductManagementEdit />
            </Suspense>
          }
        />
        <Route
          path="/ProductManagement/Add"
          element={
            <Suspense fallback={<Loader />}>
              <ProductManagementAdd />
            </Suspense>
          }
        />
        <Route
          path="/HelpAndSupport"
          element={
            <Suspense fallback={<Loader />}>
              <HelpAndSupport />
            </Suspense>
          }
        />
        <Route
          path="/HelpAndSupport/:id"
          element={
            <Suspense fallback={<Loader />}>
              <HelpAndSupportView />
            </Suspense>
          }
        />
        <Route
          path="/ContentManagement"
          element={
            <Suspense fallback={<Loader />}>
              <ContentManagement />
            </Suspense>
          }
        />
        <Route
          path="/ContentManagement/:id"
          element={
            <Suspense fallback={<Loader />}>
              <ContentManagementView />
            </Suspense>
          }
        />
        <Route
          path="/ContentManagement/Edit/:id"
          element={
            <Suspense fallback={<Loader />}>
              <ContentManagementEdit />
            </Suspense>
          }
        />
        <Route
          path="/OrderManagement"
          element={
            <Suspense fallback={<Loader />}>
              <OrderManagement />
            </Suspense>
          }
        />
        <Route
          path="/OrderManagement/:id"
          element={
            <Suspense fallback={<Loader />}>
              <OrderManagementView />
            </Suspense>
          }
        />
        <Route
          path="/TransactionManagement"
          element={
            <Suspense fallback={<Loader />}>
              <TransactionManagement />
            </Suspense>
          }
        />

        <Route
          path="/ChemicalTenderManagement"
          element={
            <Suspense fallback={<Loader />}>
              <ChemicalTenderManagement />
            </Suspense>
          }
        />
        <Route
          path="/ChemicalTenderManagement/:id"
          element={
            <Suspense fallback={<Loader />}>
              <ChemicalTenderManagementView />
            </Suspense>
          }
        />
        <Route
          path="/ChemicalTenderManagement/Add"
          element={
            <Suspense fallback={<Loader />}>
              <AddChemical />
            </Suspense>
          }
        />
        <Route
          path="/ChemicalTenderManagement/Edit/:id"
          element={
            <Suspense fallback={<Loader />}>
              <EditChemical />
            </Suspense>
          }
        />
        <Route
          path="/SubscriptionManagement"
          element={
            <Suspense fallback={<Loader />}>
              <SubscriptionManagement />
            </Suspense>
          }
        />
         <Route
          path="/DocumentRequestManagement"
          element={
            <Suspense fallback={<Loader />}>
              <DocumentRequestManagement />
            </Suspense>
          }
        />
         <Route
          path="/DocumentRequestManagement/:id"
          element={
            <Suspense fallback={<Loader />}>
              <DocumentRequestManagementView />
            </Suspense>
          }
        />
        <Route
          path="/SubscriptionManagement/:id"
          element={
            <Suspense fallback={<Loader />}>
              <SubscriptionManagementView />
            </Suspense>
          }
        />
          <Route
          path="/SubscriptionManagement/Add"
          element={
            <Suspense fallback={<Loader />}>
              <SubscriptionManagementAdd />
            </Suspense>
          }
        />
         <Route
          path="/SubscriptionManagement/Edit/:id"
          element={
            <Suspense fallback={<Loader />}>
              <SubscriptionManagementEdit />
            </Suspense>
          }
        />
      </Route>

      {/* Catch-all route for unmatched paths */}
      {/* <Route
        path="*"
        element={
          <Suspense fallback={<Loader />}>
            <ErrorPage />
          </Suspense>
        }
      /> */}
    </Routes>
  );
}

export default App;
